"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeZoneNote = exports.TimeZoneNoteDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var html_1 = require("../elements/html");
var sprintf_js_1 = require("sprintf-js");
var cls = (0, utils_1.classNames)('time-zone-note');
exports.TimeZoneNoteDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", " ", ";\n    font-size: 0.85em;\n    color: ", ";\n    display: block;\n    line-height: 1.5em;\n  "], ["\n    padding: ", " ", ";\n    font-size: 0.85em;\n    color: ", ";\n    display: block;\n    line-height: 1.5em;\n  "])), theme_1.theme.UNIT(1), theme_1.theme.UNIT(2.5), theme_1.theme.COLOR('text'))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(html_1.HTML)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
var TimeZoneNote = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity;
  var text = (0, sprintf_js_1.sprintf)('%s (%s)<br />(UTC%s)', entity.name, entity.abbreviation, entity.utcOffset);
  return react_1.default.createElement(My.Container, {
    text: text,
    className: cls.name(className)
  });
};
exports.TimeZoneNote = TimeZoneNote;
exports.TimeZoneNote.defaultProps = exports.TimeZoneNoteDefaultProps;
exports.TimeZoneNote.cls = cls;
var templateObject_1, templateObject_2;